import {connect} from "react-redux";
import {App, DispatchProps, InnerProps, StateProps} from "../components/App";
import {RootState, ThunkDispatch} from "../types";
import {doGetApiKeys, doGetUserCredits, doLoggedUser} from "../actions/thunks/users";

function mapStateToProps({user}: RootState): StateProps {
    return {
        loadingUser: user.loading,
        loggedUser: user.user,
        credentials: user.credentials,
        userCredits: user.credits,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onDoLoggedUser: () => dispatch(doLoggedUser()),
        onGetApiKeys: (ignoreAuthResponse) => dispatch(doGetApiKeys(ignoreAuthResponse)),
        onGetUserCredits: () => dispatch(doGetUserCredits()),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(App);
